import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

// Declare the global window property for TypeScript
declare global {
  interface Window {
    toggleTheme?: () => void;
  }
}

const ThemeToggle: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // On component mount, check if user has a theme preference
  useEffect(() => {
    // Check for saved theme preference or prefer-color-scheme
    const isDark = 
      localStorage.getItem('theme') === 'dark' || 
      (localStorage.getItem('theme') !== 'light' && 
        window.matchMedia('(prefers-color-scheme: dark)').matches);
    
    setIsDarkMode(isDark);
    
    // Apply the theme class to document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  // Toggle between dark and light mode
  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    
    // Save preference to localStorage
    localStorage.setItem('theme', newMode ? 'dark' : 'light');
    
    // Toggle dark class on html element
    if (newMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <button 
      onClick={toggleTheme}
      className="p-2 rounded-full transition-colors hover:bg-gray-200 dark:hover:bg-catppuccin-surface0"
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? (
        <Sun size={20} className="text-catppuccin-yellow" />
      ) : (
        <Moon size={20} className="text-gray-600" />
      )}
    </button>
  );
};

export default ThemeToggle; 